/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { map } from 'lodash';

import { Button } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import CourseCard from 'bundles/expression-of-interest/components/eoi-v1/modal-content/CourseCard';
import S12nCard from 'bundles/expression-of-interest/components/eoi-v1/modal-content/S12nCard';
import TrackedButton from 'bundles/page/components/TrackedButton';
import { RecommendationTypes } from 'bundles/university-program-qualification/utils/constants';
import { getRecommendationType } from 'bundles/university-program-qualification/utils/utils';
import type { EoiSectionPropTypes } from 'bundles/xddp/types';

import _t from 'i18n!nls/university-program-qualification';

const styles = {
  terminalSection: css`
    .section-title {
      margin-top: 10px;
    }

    .section-description {
      margin-top: 20px;
      margin-bottom: 40px;
    }

    .recommendation-list {
      .list-card-container {
        margin-bottom: 12px;
      }

      button {
        margin-right: 12px;
      }
    }
  `,
};

export type TerminalSectionProps = {
  sectionData?: EoiSectionPropTypes;
  eoiConfirmationText?: string;
};

const TerminalSection: React.FC<TerminalSectionProps> = ({ sectionData, eoiConfirmationText }) => {
  if (!sectionData) {
    return <div className="section-title headline-5-text">Loading...</div>;
  }

  const { recommendations, applyLink, brochureLink } = sectionData;

  return (
    <div className="rc-TerminalSection" css={styles.terminalSection}>
      <header className="section-header">
        <div className="section-description">
          <Markdown source={eoiConfirmationText} />
        </div>
      </header>
      <div className="recommendation-list">
        {map(recommendations, (recommendation) => {
          const recommendationType = getRecommendationType(recommendation);
          const { id } = recommendation.definition;
          if (recommendationType === RecommendationTypes.S12N) {
            return <S12nCard s12nId={id} key={id} />;
          } else {
            return <CourseCard courseId={id} key={id} />;
          }
        })}
        {brochureLink && (
          <Button
            variant="secondary"
            trackingName="eoi_terminal_download_brochure"
            component={TrackedButton}
            withVisibilityTracking={false}
            requireFullyVisible={false}
            onClick={() => window.open(brochureLink, '_blank')}
          >
            {_t('Download Brochure')}
          </Button>
        )}
        {applyLink && (
          <Button
            variant="primary"
            trackingName="eoi_terminal_apply_now"
            component={TrackedButton}
            withVisibilityTracking={false}
            requireFullyVisible={false}
            onClick={() => window.open(applyLink, '_blank')}
          >
            {_t('Apply Now')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default TerminalSection;
